module.exports = __webpack_public_path__ + "img/viewfeedback.3d1bfa73.svg";